import { Button, Flex, Form, Modal, Typography } from "antd"
import React from "react"

import { normalizeEmail } from "../../../utils/form/normalizeEmail.tsx"
import { EmailModalStateAction } from "../types/customer.types.ts"
import { TextInput } from "../../../components/Input/TextInput.tsx"

const { Text, Title } = Typography

const meta = {
  [EmailModalStateAction.invite]: {
    title:
      "This customer doesn't have an email address. Please add one to send the invitation.",
    button: "Save & Send Invite"
  },
  [EmailModalStateAction.resend_invite]: {
    title:
      "This customer doesn't have an email address. Please add one to send the invitation.",
    button: "Save & Send Invite"
  },
  [EmailModalStateAction.suspend]: {
    title:
      "This customer doesn't have an email address. Please add one to suspend the user.",
    button: "Save & Suspend"
  }
}

interface AddEmailModalProps {
  loading: boolean
  onSubmit: (email: string) => void
  onCancel: () => void
  action: EmailModalStateAction
}

export const AddEmailModal = ({
  loading,
  onSubmit,
  onCancel,
  action
}: AddEmailModalProps) => {
  const [form] = Form.useForm()

  const handleFinish = ({ email }: { email: string }) => {
    onSubmit(email)
  }

  const metaData = meta?.[action]

  return (
    <Modal
      open
      centered
      title={
        <Title level={3} style={{ textAlign: "left" }}>
          Add Email Address
        </Title>
      }
      onCancel={onCancel}
      footer={null}
      maskClosable={false}
      width={440}
    >
      <Text type="secondary" className="block mb-4">
        {metaData?.title}
      </Text>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        validateTrigger={["onSubmit", "onChange"]}
        className="mt-4"
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please enter email" },
            { type: "email", message: "Please enter a valid email" }
          ]}
          normalize={normalizeEmail}
        >
          <TextInput
            placeholder="example@email.com"
            size="large"
            disableAutoCapitalize
          />
        </Form.Item>
        <Form.Item noStyle>
          <Flex align="center" justify="flex-end" gap="middle">
            <Button size="large" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              {metaData?.button}
            </Button>
          </Flex>
        </Form.Item>
      </Form>
    </Modal>
  )
}
